import React from 'react';

const Body = ({ 
    children, 
    isMobile = false, 
    isTablet = false, 
    isDesktop = false, 
    style, 
    className, 
    id,
    ...props 
}) => {
    return (
        <div className={`dc-haslayout dc-dbsectionspace ${className}`} id={id} style={style} {...props}>

            <div className="container-fluid py-3">
                {children}
            </div>
        </div>
        
    );
};

export default Body;
